import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormOctagonRotate: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-octagon-rotate"} maskId="square-filled-radius-0-stroke-1-IconFormOctagonRotate"><path d="M19.4561 4.5459L22.543 12L19.4561 19.4541L12.002 22.541L4.54785 19.4541L1.46094 12L4.54785 4.5459L12.002 1.45898L19.4561 4.5459Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormOctagonRotate;
